import React from "react";
import DeliveryModesPageGen from "./generated/DeliveryModesPageGen";
import deliveryModesService from "../../../services/legacy/deliveryModesService";

const SHOW_IN_GRID = new Set(["code", "txt"]);
const SHOW_IN_FILTER = new Set(["code", "txt"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const DeliveryModesPage = () => {
  const service = deliveryModesService;
  return <DeliveryModesPageGen service={service} transformColumns={transformColumns} />;
};

export default DeliveryModesPage;